import { SVGProps, Ref, forwardRef } from 'react';

export const ZarplataSolidSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0M4.62 9.867v1.196a.36.36 0 0 0 .223.332c.768.33 1.71.5 2.847.5 1.171 0 2.121-.237 2.834-.713q1.092-.735 1.091-1.852c0-.93-.552-1.545-1.295-1.828-.051-.02-.053-.093-.003-.114.654-.278.982-.826.982-1.634 0-.618-.333-1.14-.982-1.552q-.973-.617-2.421-.617c-1.106 0-2.056.156-2.826.47a.36.36 0 0 0-.229.335v1.14a.237.237 0 0 0 .324.222c.665-.266 1.412-.394 2.24-.394q1.614 0 1.615.76c0 .459-.38.696-1.14.696H6.57a.24.24 0 0 0-.241.242v1.13a.24.24 0 0 0 .242.242H7.88c.934 0 1.393.254 1.393.776 0 .586-.697.918-1.9.918-.878 0-1.685-.155-2.42-.474a.24.24 0 0 0-.334.22"
            fill="currentColor"
        />
    </svg>
));
ZarplataSolidSize16Glyph.displayName = 'ZarplataSolidSize16Glyph';
